<template>
    <div class="modal-overlay" @click.self="emitClose">
        <div class="modal">
            <div class="modal-header">
                <h1 class="modal-title">Czy na pewno chcesz opuścić konfigurator?</h1>
                <button class="close-button" @click="emitClose">
                    <font-awesome-icon icon="xmark" size="xs" />
                </button>
            </div>
            <div class="modal-content">
                <p class="warning-text">Twój aktualny postęp konfiguracji zostanie utracony.</p>
                <div class="modal-actions">
                    <button class="exit-button" @click="exitToModelSelection">
                        Tak, chcę opuścić konfigurator
                    </button>
                    <button class="cancel-button" @click="emitClose">Kontynuuj konfigurację</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { clearConfigStorage } from '@/services/configStorage';

export default {
    name: 'ExitConfigModal',
    emits: ['close'],
    methods: {
        emitClose() {
            this.$emit('close');
        },
        exitToModelSelection() {
            clearConfigStorage();
            this.$router.push('/models');
        }
    }
};
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
}

.modal {
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    background-color: $color-background;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 20px;
    background-color: $color-primary;
    color: $color-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    flex: 1;
}

.close-button {
    background: none;
    border: none;
    color: $color-white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0 10px;
    line-height: 1;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.modal-content {
    padding: 20px;
}

.warning-text {
    color: $color-text-light;
    text-align: center;
    margin-bottom: 20px;
    font-size: 1rem;
}

.modal-actions {
    display: flex;
    gap: 15px;
    padding-top: 10px;

    button {
        flex: 1;
        padding: 12px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 500;
        transition: all 0.3s ease;
    }

    .exit-button {
        background-color: $color-grey;
        color: $color-text;

        &:hover {
            background-color: $color-grey-dark;
        }
    }

    .cancel-button {
        background-color: $color-primary;
        color: $color-white;

        &:hover {
            background-color: $color-primary-dark;
        }
    }
}

@media (max-width: 768px) {
    .modal-actions {
        flex-direction: column;
        gap: 10px;

        button {
            width: 100%;
        }
    }

    .modal-header {
        padding: 15px;
    }

    .modal-title {
        font-size: 1.2rem;
        text-align: left;
        padding-right: 10px;
    }

    .close-button {
        font-size: 1.2rem;
    }
}
</style>